import { usePQRouter } from "@/shared/composables/price-quotes/usePQRouter"

export default [
  {
    path: "/cotizaciones",
    name: "price-quotes",
    meta: { requiresAuth: true },
    redirect: { name: "price-quotes-list" },
    children: [
      {
        path: "",
        name: "price-quotes-list",
        component: () => import("@/modules/price-quotes/views/PriceQuotesList.vue"),
      },
      {
        path: ":id",
        name: "price-quotes-show",
        component: () => import("@/modules/price-quotes/views/PriceQuoteShow.vue"),
      },{
        path: 'add',
        name: 'price-quotes-add',
        component: () => import('@/modules/price-quotes/views/PriceQuoteAdd.vue')
      },{
        path: ':id/editar',
        name: 'price-quotes-edit',
        component: () => import('@/modules/price-quotes/views/PriceQuoteEdit.vue'),
        meta: {
          requiresAuth: true,
          roles: ['supervisor_abarrotes', 'supervisor_granos', 'superadmin', 'admin','vendedor'],
        },
        beforeEnter: async (to, from, next) => {
          const {statusReturned} =  usePQRouter();
          if (statusReturned.value) {
            next({ name: 'price-quotes-show', params: { id: to.params.id } })
          } else {
            next()
          }
        }
        
      },{
        path: ':id/editar-devuelto',
        name: 'price-quotes-edit-return-status',
        component: () => import('@/modules/price-quotes/views/PriceQuoteEditReturnStatus.vue'),
        meta: {
          requiresAuth: true,
          roles: ['supervisor_abarrotes', 'supervisor_granos', 'superadmin', 'admin','vendedor'],
        },
        beforeEnter: async (to, from, next) => {
          const {statusReturned} =  usePQRouter();
          if (statusReturned.value) {
            next()
          } else {
            next({ name: 'price-quotes-show', params: { id: to.params.id } })
          }
        }
      }
      ,{
        path: ':id/add-payment',
        name: 'price-quote-payment',
        component : () => import('@/modules/price-quotes/views/PriceQuotePayment.vue')
      },
      {
        path: ":id/map",
        name: "price-quote-show-map",
        component: () => import('@/modules/price-quotes/views/PriceQuoteShowMap.vue')
      }
    ],
  },
]
